import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import Text from '../Text';
import clsx from 'clsx';
import { IDescriptiveRadioInputExtraProps } from './IDescriptiveRadioInputProps';

const DescriptiveRadioInput = forwardRef<HTMLInputElement, IDescriptiveRadioInputExtraProps>(
  (props, forwardedRef) => {
    const {
      title,
      description,
      icon: Icon,
      iconUrl,
      className,
      labelClassName,
      checked,
      ...rest
    } = props;

    if (Icon && iconUrl) {
      throw new Error('Radio Input cannot use both icon and iconUrl');
    }

    return (
      <div className="flex w-full items-center h-auto">
        <label
          className={twMerge(
            clsx({
              'flex w-full items-center gap-3 rounded-xl border px-6 py-5 h-auto cursor-pointer':
                true,
              'border-mobile-hero-100': checked,
              'border-retail-gray-100': !checked,
            }),
            labelClassName,
          )}
          htmlFor={rest.id}
        >
          {Icon || null}
          {iconUrl ? (
            <img
              src={iconUrl}
              alt="radio-input-image"
              height={48}
              width={48}
              className="h-12 w-12"
              loading="eager"
            />
          ) : null}
          <div className="flex gap-4">
            <input
              className={twMerge(
                'accent-mobile-hero-100 text-mobile-hero-100 h-5 w-5 mr-auto mt-1 grow shrink-0 basis-auto',
                className,
              )}
              type="radio"
              ref={forwardedRef}
              checked={checked}
              onChange={rest.onChange}
              name={rest.name}
              id={rest.id}
              value={rest.value}
            />
            <span>
              <Text variant="h4" className="font-chromatica">
                {title}
              </Text>
              {description ? (
                <p className="text-mobile-text-hierarchy mt-1 block">
                  {description}
                </p>
              ) : null}
            </span>
          </div>
        </label>
      </div>
    );
  },
);

DescriptiveRadioInput.displayName = 'DescriptiveRadioInput';

export default DescriptiveRadioInput;
